export enum ErrorType {
  PathParams = 'path-total-error',
  SchemaError = 'schema-error',
  PathError = 'path-error',
  Debug = 'debug',
}
export const ErrorTypeDesc = {
  [ErrorType.PathParams]: '路径参数数量匹配不上文档',
  [ErrorType.SchemaError]: '接口参数解析出问题',
  [ErrorType.PathError]: '路径参数类型没写为path',
  [ErrorType.Debug]: 'debug数据',
};
interface ErrorUrl {
  desc?: string;
  url: string;
  method: string;
  errorType: ErrorType;
  errMsg?: string;
}
class Store {
  errorUrl: ErrorUrl[] = [];
  isTypeScript: boolean = true;
  isJsDoc: boolean = false;
  errorPath?: string = '';
  filename?: string = '';
  logFilename?: string = '';
  
  constructor() {}

  pushError(data: ErrorUrl) {
    this.errorUrl.push(data);
  }
  
  print() {
    const errTypeHash = this.errorUrl.reduce((pre, next) => {
      if (!pre[next.errorType]) {
        pre[next.errorType] = [];
      }
      pre[next.errorType].push({
        ...next,
        errorType: ErrorTypeDesc[next.errorType],
      });
      return pre;
    }, {} as Record<string, any[]>);
    return JSON.stringify(errTypeHash);
  }
  getFileType() {
    if (this.isTypeScript) {
      return '.ts';
    }
    return '.js';
  }
}
const store = new Store();

export default store;
